import HttpClienteToken from '../../services/HttpClientToken';

import { TipoConceptoProps } from '../../interfaces/catalogos/TipoConceptoInterface';

export const TipoConceptos = () => {

    return new Promise<TipoConceptoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoConcepto/', token)
            .then( ({ data } : { data : TipoConceptoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoConceptos = () => {

    return new Promise<TipoConceptoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoConcepto/ObtenerTipoConceptos', token)
            .then( ({ data } : { data : TipoConceptoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoConcepto = ( params: TipoConceptoProps ) => {

    return new Promise<TipoConceptoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoConcepto/Actualizar', params, token)
            .then( ({ data } : { data : TipoConceptoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoConcepto: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoConcepto = ( params: TipoConceptoProps ) => {

    return new Promise<TipoConceptoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoConcepto/Agregar', params, token)
            .then( ({ data } : { data : TipoConceptoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoConcepto: 0,
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}